<template>
  <div class="ui-toggle-button" :class="[{'is-checked': isChecked}, color]">
    <ui-button type="normal" button-type="button"
               :disabled="disabled" @click.native="onClick">
      <slot></slot>
    </ui-button>
  </div>
</template>

<script>
  export default {
    name: 'ui-toggle-button',
    data () {
      return {
        isChecked: false
      }
    },
    props: {
      color: {
        type: String
      },
      name: {
        type: String
      },
      group: {
        type: String
      },
      disabled: {
        type: Boolean
      }
    },
    created () {
      this.$on('test', this.forceChange)
    },
    destroyed () {
      this.$off('test', this.forceChange)
    },
    methods: {
      onClick: function (ev) {
        ev.preventDefault()
        ev.stopPropagation()

        this.isChecked = !this.isChecked
        this.$emit('change', this)
      },
      check: function () {
        this.isChecked = true
      },
      uncheck: function () {
        this.isChecked = false
      }
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import '~scss/variables';

  .ui-toggle-button {
    .ui-button {
      height: 35px;
      background-color: $grey-30;
      text-align: center;
      border-radius: 0;
      width: 100%;
      line-height: 35px;
      font-size: 11px;
      color: $grey-70;
      -webkit-user-select: none;  /* Chrome all / Safari all */
      -moz-user-select: none;     /* Firefox all */
      -ms-user-select: none;      /* IE 10+ */
      user-select: none;          /* Likely future */

      &:hover {
        background-color: darken($grey-30, 5%);
      }
    }

    &.is-checked {
      .ui-button {
        background-color: $somfy;
        &:hover{ background-color: lighten($somfy, 4%); }
      }


      &.warning {
        .ui-button {
          background-color: $warning;
          &:hover{ background-color: lighten($warning, 4%); }
        }
      }
      &.danger {
        .ui-button {
          background-color: $danger;
          &:hover{ background-color: lighten($danger, 4%); }
        }
      }
      &.success-light {
        .ui-button {
          background-color: $success-light;
          &:hover{ background-color: lighten($success-light, 4%); }
        }
      }
      &.success-medium {
        .ui-button {
          background-color: $success-medium;
          &:hover{ background-color: lighten($success-medium, 4%); }
        }
      }
      &.success-strong {
        .ui-button {
          background-color: $success-strong;
          &:hover{ background-color: lighten($success-strong, 4%); }
        }
      }

      .ui-button {
        color: $body-light;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// UIToggleButton.vue?c75f892c